<template>
  <div class="eddy-sorting-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>楞次定律在固废回收中的应用</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Conveyor Belt -->
          <rect x="20" y="160" width="280" height="10" fill="#333" />
          
          <!-- Magnetic Rotor (The "Pusher") -->
          <g transform="translate(300, 165)">
             <circle r="25" fill="#444" stroke="#ffd700" stroke-width="2">
                <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="0.5s" repeatCount="indefinite" />
             </circle>
             <line x1="-20" y1="0" x2="20" y2="0" stroke="#ff4757" stroke-width="4" />
             <line x1="0" y1="-20" x2="0" y2="20" stroke="#00d2ff" stroke-width="4" />
          </g>

          <!-- Falling Items -->
          <g v-for="item in items" :key="item.id" :transform="`translate(${item.x}, ${item.y})`">
             <!-- Non-conductive item (Plastic) -->
             <rect v-if="item.type === 'plastic'" width="15" height="15" fill="#555" />
             <!-- Conductive item (Aluminum) -->
             <rect v-else-if="item.type === 'aluminum'" width="15" height="15" fill="#00d2ff" rx="2" />
          </g>

          <!-- Bins -->
          <rect x="320" y="210" width="30" height="30" fill="rgba(85,85,85,0.4)" />
          <text x="315" y="235" fill="#888" font-size="8">塑料类</text>

          <rect x="360" y="210" width="30" height="30" fill="rgba(0,210,255,0.4)" />
          <text x="355" y="235" fill="#00d2ff" font-size="8">铝金属</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>智能分选：利用感应电流的斥力实现铝/塑分离</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
         <div class="control-card glass">
            <el-button type="primary" size="mini" @click="spawnItems">开始分选</el-button>
         </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>涡流分选机内部有一个高速旋转的磁转子。当混合垃圾经过转子上方时，导电金属（如铝）内部会产生强烈的**涡电流**。根据楞次定律，这些电流产生的磁场与转子磁场方向相反，产生巨大的**感应斥力**，将铝片“弹射”到更远的容器中。而塑料、玻璃等非导电物质不受影响，直接落下。这是现代环保回收中心的核心黑科技。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EddyCurrentSortingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      items: [],
      timer: null,
      spawnTimer: null
    }
  },
  methods: {
    spawnItems() {
       if (this.spawnTimer) return;
       this.update();
       this.spawnTimer = setInterval(() => {
          this.items.push({
             id: Date.now() + Math.random(),
             x: 20,
             y: 145,
             type: Math.random() > 0.5 ? 'aluminum' : 'plastic',
             vx: 3,
             vy: 0,
             state: 'on_belt'
          });
       }, 800);
    },
    update() {
       this.items.forEach((it) => {
          if (it.state === 'on_belt') {
             it.x += it.vx;
             if (it.x >= 280) {
                it.state = 'interact';
                if (it.type === 'aluminum') {
                   it.vx = 6;  // Repelled forward
                   it.vy = -3; // Jump
                } else {
                   it.vx = 2; // Normal tumble
                   it.vy = 2;
                }
             }
          } else {
             it.x += it.vx;
             it.y += it.vy;
             it.vy += 0.3; // Gravity
          }
          if (it.y > 240) it.toRemove = true;
       });
       this.items = this.items.filter(it => !it.toRemove);
       this.timer = requestAnimationFrame(this.update);
    }
  },
  beforeDestroy() {
     if (this.timer) cancelAnimationFrame(this.timer);
     if (this.spawnTimer) clearInterval(this.spawnTimer);
  }
}
</script>

<style scoped lang="scss">
.eddy-sorting-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
